import { ApolloLink } from 'apollo-link';
import { getCSRFToken } from 'Jsx/Utils';

const csrfTokenMiddleware = new ApolloLink((operation, forward) => {
  const csrfToken = getCSRFToken();

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'X-CSRFToken': csrfToken,
    },
  }));

  return forward(operation);
});

export default csrfTokenMiddleware;
